<template>
	<div class="footer-area">
		<div class="footer" id="footer">
			<div class="container clearfix">
				<div class="footer-content">
					<div class="fc-left">
						<ul class="fc-left-ul">
							<li class="first">
								<a>关于商会</a>
							</li>
							<li>
								<router-link to="/list?title=组织机构&type=36">组织机构</router-link>
							</li>
							<li>
								<router-link to="/list?title=商会时事&type=30">商会时事</router-link>
							</li>
						</ul>
						<ul class="fc-left-ul">
							<li class="first">
								<a>新闻动态</a>
							</li>
							<li>
								<router-link to="/list?title=商会时事&type=57&index=2">商会时事</router-link>
							</li>
							<li>
                <router-link to="/list?title=国内新闻&type=20&index=4-1">国内新闻</router-link>
							</li>
							<li>
                <router-link to="/list?title=国外新闻&type=21&index=4-2">国外新闻</router-link>
							</li>
							<li>
                <router-link to="/list?title=外埠新闻&type=29&index=4-3">外埠新闻</router-link>
							</li>
						</ul>
						<ul class="fc-left-ul">
							<li class="first">
								<a>服务中心</a>
							</li>
							<li>
								<router-link to="/list?title=法律服务&type=44">法律服务</router-link>
							</li>
							<li>
								<router-link to="/list?title=金融服务&type=45">金融服务</router-link>
							</li>
							<li>
								<router-link to="/list?title=劳务服务&type=46">劳务服务</router-link>
							</li>
							<li>
								<router-link to="/list?title=健康服务&type=47">健康服务</router-link>
							</li>
						</ul>
						<ul class="fc-left-ul">
							<li class="first">
								<a>招商引资</a>
							</li>
							<li>
								<router-link to="/list?title=招商信息发布&type=32">招商信息发布</router-link>
							</li>
							<li>
								<router-link to="/list?title=招商政策解读&type=33">招商政策解读</router-link>
							</li>
							<li>
								<router-link to="/list?title=外埠招商动态&type=34">外埠招商动态</router-link>
							</li>
							<li>
								<router-link to="/list?title=招商成果展示&type=35">招商成果展示</router-link>
							</li>
						</ul>
						<ul class="fc-left-ul">
							<li class="first">
								<a>官方微信</a>
							</li>
							<li class="QRcode">
								<img src="@/assets/img/qrcode.png" width="100%" height="100%">
							</li>
						</ul>
					</div>
					<div class="fc-right">
						<ul class="fc-right-ul">
							<li class="first">
								<a>联系我们</a>
							</li>
							<li>
								<p>电话：15567113487</p>
							</li>
							<li>
								<p>邮箱：jlsydshlhh@163.com</p>
							</li>
							<li>
								<p>地址：吉林省长春市环球贸易中心2号楼4楼</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="footer-bottom">吉林省异地商会联合会版权所有&nbsp;&nbsp;Copyright © 2021 All Right Reserved&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/">吉ICP备2021004791号-1</a>&nbsp;&nbsp;技术支持：
				<a href="http://www.zhengshang100.com/">政商通大数据有限公司</a>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: "nav_footer",
};
</script>

<style scoped>
.footer {
    min-height: 350px;
    height: auto !important;
    background-color: #0286c7;
    position: relative;
}

.container {
    width: 1200px;
    margin: auto;
}

.fc1 {
    width: 310px;
    float: left;
}

.blogobox {
    height: 158px;
    border-bottom: 1px solid #383838;
    width: 226px;
    display: block;
    margin-right: 100px;
    float: left;
}

.bottom_logo {
    /* background: url(images/logo2.png) no-repeat scroll 0px center; */
    width: 226px;
    height: 52px;
    display: block;
    margin-top: 58px;
}

.fc-left {
    margin: 0 auto 24px;
    float: left;
}

.fc-left-ul {
    margin-top: 45px;
    width: 120px;
    margin-right: 50px;
    float: left;
}

.fc-left-ul li {
    text-align: center;
    height: 40px;
    line-height: 40px;
}

.fc-left-ul li.first {
    font-size: 16px;
    font-weight: 100;
    height: 30px;
    line-height: 30px;
    margin-bottom: 12px;
}

.fc-left-ul li.first a {
    color: #ffffff;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
}

.fc-left-ul li a {
    color: #fff;
}

.fc-left-ul li p {
    color: #fff;
}

.QRcode {
    width: 120px;
    height: 120px !important;
}

.contact li p {
    width: 140px;
    text-align: left;
}

.fc-right {
    float: left;
    margin-left: 50px;
    overflow: hidden;
}

.footer-content {
    min-height: 280px;
    overflow: hidden;
    height: 280px;
}

.fc-right-ul {
    width: 100%;
    margin-top: 45px;
}

.fc-right-ul li {
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    color: #fff;
}

.fc-right-ul li.first {
    font-size: 16px;
    font-weight: 100;
    height: 30px;
    line-height: 30px;
    padding-bottom: 15px;
}

.fc-right-ul li.first a {
    color: #ffffff;
}

.footer-bottom {
    position: absolute;
    bottom: 0px;
    height: 66px;
    width: 100%;
    line-height: 66px;
    text-align: center;
    color: #fff;
    background-color: #0696d3;
    text-transform: uppercase;
}

.footer-bottom a {
    color: #fff;
}

.footer-bottom a:hover {
    border-bottom: 1px solid #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/nav-footer/index.vue